import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTurbosquidComponent } from './simple-icons-turbosquid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTurbosquidComponent ],
    exports:      [ SimpleIconsTurbosquidComponent ],
    bootstrap:    []
})
export class SimpleIconsTurbosquidModule {}
